import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { message } from "../../messages/animationSettings"
import { EButtonStyle } from "../../enums/animationSettings"

export default function useZoomSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.separate),
                value: EButtonStyle.Separate,
            },

            {
                label: intl.formatMessage(message.none),
                value: EButtonStyle.None,
            },
        ],
        [intl],
    )
}
